import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatBRL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { LogOut, Package, User } from "lucide-react";
const STATUS_LABELS = {
  received: "Recebido",
  payment_pending: "Aguardando pagamento",
  paid: "Pago",
  in_preparation: "Em separação",
  ready_for_pickup: "Pronto para retirada",
  completed: "Concluído",
  cancelled: "Cancelado",
};
export default function Account() {
  const { user, loading, logout } = useAuth();
  const [orders, setOrders] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && !user) nav("/entrar");
    if (user) api.get("/orders/mine").then((r) => setOrders(r.data));
  }, [user, loading, nav]);

  if (loading || !user) return <div className="max-w-4xl mx-auto px-4 py-16 text-center">Carregando...</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 py-6 sm:py-10">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold" style={{ fontFamily: "Outfit" }}>Olá, {user.name?.split(" ")[0]}</h1>
          <p className="text-sm text-neutral-500">{user.email}</p>
        </div>
        <Button data-testid="logout-btn" variant="outline" onClick={() => { logout(); nav("/"); }}><LogOut className="h-4 w-4 mr-2" />Sair</Button>
      </div>

      {user.role === "admin" && (
        <Link to="/admin" className="block mb-4 bg-neutral-900 text-white rounded-lg p-4 hover:bg-neutral-800">
          <p className="font-semibold">Você é administrador — acessar painel</p>
        </Link>
      )}

      <section className="bg-white border rounded-xl p-5">
        <h2 className="font-bold flex items-center gap-2 mb-4"><Package className="h-5 w-5" />Meus pedidos</h2>
        {orders.length === 0 ? (
          <p className="text-neutral-500 text-sm">Você ainda não fez nenhum pedido.</p>
        ) : (
          <ul className="space-y-3">
            {orders.map((o) => (
              <li key={o.id} className="flex items-center justify-between border rounded-lg p-3">
                <div>
                  <p className="font-semibold">#{o.order_number}</p>
                  <p className="text-xs text-neutral-500">{new Date(o.created_at).toLocaleDateString("pt-BR")} • {o.items.length} itens</p>
                </div>
                <div className="text-right">
                  <p className="font-bold text-[#C91F1F]">{formatBRL(o.total)}</p>
                  <p className="text-xs text-neutral-500">
  {STATUS_LABELS[o.status] || o.status}
</p>
                </div>
                <Link to={`/pedido/${o.id}`}><Button size="sm" variant="outline">Ver</Button></Link>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
